import { format, formatDistanceToNow, parseISO } from "date-fns";

export const fmtDate = (iso, pattern = "dd MMM yyyy") => {
  if (!iso) return "—";
  try { return format(typeof iso === "string" ? parseISO(iso) : iso, pattern); } catch { return iso; }
};
export const fmtDateTime = (iso) => fmtDate(iso, "dd MMM yyyy · HH:mm");
export const fmtAgo = (iso) => {
  if (!iso) return "";
  try { return formatDistanceToNow(parseISO(iso), { addSuffix: true }); } catch { return ""; }
};
export const fmtBytes = (n = 0) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : n > 1024 ? `${Math.round(n / 1024)} KB` : `${n} B`);
export const pad2 = (n) => String(n).padStart(2, "0");
export const roleLabel = (r) => ({ super_admin: "Super Admin", admin: "Admin", project_manager: "Project Manager", team_member: "Team Member", client: "Client" }[r] || r);

export const STATUS_TONE = {
  "Not Started": "neutral", Planning: "violet", Design: "violet", Development: "lime", Testing: "amber", Review: "amber",
  Revision: "amber", "Ready for Launch": "lime", Completed: "green", "On Hold": "neutral",
  Upcoming: "neutral", "In Progress": "lime", Delayed: "red", Todo: "neutral",
  Submitted: "violet", "Under Review": "amber", Approved: "green", Rejected: "red",
  pending: "amber", approved: "green", changes_requested: "red",
  new: "lime", viewed: "violet", contacted: "amber", completed: "green",
  Normal: "neutral", High: "amber", Urgent: "red", client: "lime", internal: "neutral",
};

export const PROJECT_STATUSES = ["Not Started", "Planning", "Design", "Development", "Testing", "Review", "Revision", "Ready for Launch", "Completed", "On Hold"];
export const PRIORITIES = ["Normal", "High", "Urgent"];
export const MILESTONE_STATUSES = ["Upcoming", "In Progress", "Completed", "Delayed"];
export const TASK_STATUSES = ["Todo", "In Progress", "Review", "Completed"];
export const UPDATE_TYPES = ["General Update", "Design Update", "Development Update", "Testing Update", "Milestone Update", "Delivery Update"];
export const REVISION_STATUSES = ["Submitted", "Under Review", "Approved", "In Progress", "Completed", "Rejected"];
export const PROJECT_TYPES = ["Website", "Web Application", "SaaS Platform", "Mobile Application", "Custom Software", "E-Commerce", "API / Backend", "UI/UX Design", "Other"];
export const STAFF_ROLES = ["super_admin", "admin", "project_manager", "team_member"];
